var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-grow flex-col items-center justify-center"},[_c('LoadingSpinner'),_c('p',{staticClass:"mt-4 font-medium text-slate-600"},[_vm._v(" "+_vm._s(_vm.$t("oauth.loading"))+"... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }